import { render, staticRenderFns } from "./PaymentFaliPage.vue?vue&type=template&id=476a8ed3&scoped=true"
import script from "./PaymentFaliPage.vue?vue&type=script&lang=js"
export * from "./PaymentFaliPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentFaliPage.vue?vue&type=style&index=0&id=476a8ed3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a8ed3",
  null
  
)

export default component.exports